var api = require("!../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/dist/cjs.js!../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--8-0!../../node_modules/vue-style-loader/index.js!../../node_modules/css-loader/index.js??ref--8-2!../../node_modules/postcss-loader/lib/index.js??ref--8-3!../../node_modules/less-loader/dist/cjs.js??ref--8-4!./index.less");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.less
// module id = CJFh
// module chunks = 0